import { jsxs, jsx } from 'react/jsx-runtime';
import { cssDropdownItemMobile } from '../DropdownMenu/Item.js';
import { Item, SubTrigger } from '@radix-ui/react-context-menu';
import { styled, css } from 'styled-components';
import { mediaNotMobile, mediaHover } from '../../constants/styled-utils.js';
import { Flex } from '../Flex.js';
import { MenuItemInfoIconTooltip } from '../Menu/MenuItemInfoIconTooltip.js';
import { preventForwardPropsConfig } from '../../utils/preventForwardProps.js';

const ContextMenuItem = styled(Item).attrs(({ disabledReason, children, disabled, onClick, onSelect, ...props }) => {
  const isDisabled = !!disabledReason || disabled;
  return {
    ...props,
    disabled: isDisabled,
    onSelect: isDisabled ? void 0 : onSelect,
    /**
    * the radix item is <div data-disabled />, doesn't have native disabled properties like a button
    * we need to disable the onClick event manually
    */
    onClick: (e) => {
      if (isDisabled) {
        e.preventDefault();
        e.stopPropagation();
      } else {
        onClick?.(e);
      }
    },
    children: disabledReason ? /* @__PURE__ */ jsxs(Flex, {
      alignItems: "center",
      gap: "text",
      justifyContent: "space-between",
      flexGrow: true,
      children: [
        children,
        " ",
        /* @__PURE__ */ jsx(MenuItemInfoIconTooltip, {
          label: disabledReason
        })
      ]
    }) : children
  };
}).withConfig(preventForwardPropsConfig([
  "variant",
  "disabledReason"
])).withConfig({
  displayName: "ContextMenuItem",
  componentId: "sc-fd97bc05-0"
})([
  ``,
  `{padding:8px;color:white;cursor:pointer;background:none;border:1px solid transparent;outline:none;&[data-disabled]{pointer-events:unset;}font-weight:400;font-size:13px;line-height:16px;display:flex;align-items:center;border-radius:9px;&[data-disabled]{cursor:not-allowed;color:rgba(255,255,255,0.4);}`,
  `{&:hover:not([data-disabled]){background:rgba(255,255,255,0.2);border:1px solid rgba(255,255,255,0.1);}}`,
  ` &.item__context_menu__button_share{border-top:1px solid #ffffff1a;border-bottom:1px solid #ffffff1a;}> kbd{margin-left:auto;font-weight:500;font-size:12px;line-height:13px;height:19px;color:rgba(255,255,255,0.7);background:rgba(255,255,255,0.2);border-radius:4px;padding:2.5px 2px;display:flex;align-items:center;font-family:'Inter',sans-serif;> svg{width:12px;height:12px;margin-right:2px;}> span{margin-bottom:1px;}}}`,
  ``
], mediaNotMobile, mediaHover, (p) => p.variant === "danger" && css([
  `color:#ff0000;`
]), cssDropdownItemMobile);
const ContextMenuSubTrigger = styled(ContextMenuItem).attrs({
  as: SubTrigger
}).withConfig({
  displayName: "ContextMenuItem__ContextMenuSubTrigger",
  componentId: "sc-fd97bc05-1"
})([
  ``
]);

export { ContextMenuItem, ContextMenuSubTrigger };
//# sourceMappingURL=ContextMenuItem.js.map
